import React, {useState} from 'react';
import {Button, Stack, Typography} from "@mui/material";
import CreateIRDialog from './CreateIRDialog';

const IRHeader = () => {
    const [open, setOpen] = useState(false);
    const openDialog = () => setOpen(true);
    const closeDialog = () => setOpen(false);

    return (
        <>
            <Stack direction={'row'} spacing={2} align={'center'} justifyContent={'space-between'}>
                <Typography variant={'h5'}>Intelligence Requirements</Typography>
                <Button onClick={openDialog} variant="contained">Create new IR</Button>
            </Stack>

            <CreateIRDialog open={open} onClose={closeDialog}/>
        </>
    );
};

export default IRHeader;
